import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import {
  FaArrowRight,
  FaBookOpen,
  FaClipboardCheck,
  FaCertificate,
  FaComments,
  FaHeadset,
  FaBolt,
} from 'react-icons/fa';
import { EduGenieAvatarImg } from '../edugenie/edugenieBrand';

const CAPABILITIES = [
  { icon: FaBookOpen, label: 'Find & resume courses' },
  { icon: FaClipboardCheck, label: 'Track assessments' },
  { icon: FaCertificate, label: 'Certificates & badges' },
  { icon: FaComments, label: 'Live sessions & VILT' },
  { icon: FaHeadset, label: 'Raise support tickets' },
  { icon: FaBolt, label: 'Instant platform help' },
];

const SAMPLE_PROMPTS = [
  'What courses am I enrolled in?',
  'Show my upcoming assessments',
  'How do I download my certificate?',
];

const EduGenieShowcase = () => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate('/login');
  };

  return (
    <section id="ethora-bot" className="landing-edugenie py-5" aria-labelledby="edugenie-landing-heading">
      <Container>
        <Row className="align-items-center g-4 g-lg-5">
          <Col lg={6} className="order-2 order-lg-1">
            <div className="reveal reveal-up">
              <p className="landing-section-eyebrow mb-2">AI Learning Assistant</p>
              <h2 id="edugenie-landing-heading" className="landing-section-title mb-3">
                Meet <em className="landing-edugenie-name">Ethora Bot</em>
              </h2>
              <p className="landing-section-desc mb-4">
                Your intelligent learning assistant inside Ethosboard. Ask about courses, assessments,
                certificates, and support — get instant answers powered by Ethosboard, without leaving
                your learning journey.
              </p>

              <ul className="landing-edugenie-caps list-unstyled mb-4">
                {CAPABILITIES.map(({ icon: Icon, label }) => (
                  <li key={label} className="landing-edugenie-cap">
                    <span className="landing-edugenie-cap-icon" aria-hidden="true">
                      <Icon size={14} />
                    </span>
                    <span>{label}</span>
                  </li>
                ))}
              </ul>

              <button
                type="button"
                className="landing-btn-primary"
                onClick={handleSignIn}
                aria-label="Sign in to chat with Ethora Bot"
              >
                Sign in to chat with Ethora Bot
                <FaArrowRight size={14} aria-hidden="true" />
              </button>
              <p className="landing-edugenie-note mt-3 mb-0">
                Available after sign-in · Powered by Ethosboard
              </p>
            </div>
          </Col>

          <Col lg={6} className="order-1 order-lg-2">
            <div className="landing-edugenie-panel reveal reveal-up">
              <div className="landing-edugenie-panel-glow" aria-hidden="true" />
              <div className="landing-edugenie-avatar-wrap">
                <EduGenieAvatarImg
                  className="landing-edugenie-avatar"
                  alt="Ethora Bot — Your Intelligent Learning Assistant"
                />
              </div>
              <div className="landing-edugenie-chat-preview" role="presentation">
                <div className="landing-edugenie-chat-head">
                  <span className="landing-edugenie-badge">Ethosboard</span>
                  <span className="landing-edugenie-chat-title">Ethora Bot</span>
                </div>
                <p className="landing-edugenie-chat-intro mb-3">
                  Try asking after you sign in:
                </p>
                <ul className="list-unstyled mb-0">
                  {SAMPLE_PROMPTS.map((prompt) => (
                    <li key={prompt} className="landing-edugenie-prompt">
                      “{prompt}”
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EduGenieShowcase;
